import CaseStudies from "../../../../content/instructor/case-studies";
import React from 'react';
export default {
  CaseStudies,
  React
};